import axios from "axios";
import router from "../router";
import { Message, MessageBox } from 'element-ui';
import { Session } from '@/utils/storage';
import { getDomain, getHttp } from "@/utils/toos"


// create an axios instance
const service = axios.create({
  // baseURL:"http://192.168.2.74:8080", //文达
  // baseURL: getHttp(), //测试服务器
  // baseURL:'https://api.mt.posedu.com.cn', //线上
  baseURL:'https://api.match.posedu.com.cn', //线上
  // baseURL:"http://192.168.2.68:8081", //昊轩
  // baseURL:"http://192.168.2.126:8080", //大哥
  // baseURL: getUrl(), // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000, // request timeout
  headers: { 'Content-Type': 'application/json' },
});

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {

    // let domain = getDomain()
    // console.log("获取到domain",domain)
    // if(domain && domain != "localhost"){
    // 	if(config.method === 'post') {
    // 		if(typeof(config.data) == "object"){
    // 			config.data.domain=domain
    // 			config.data = JSON.stringify(config.data);
    // 		}else{
    // 		    let dataStr=JSON.parse(config.data);
    // 			dataStr.domain=domain
    // 			config.data = JSON.stringify(dataStr);
    // 		}

    // 	} else if(config.method === 'get') {
    // 		// if(typeof(config.params) == "object"){
    // 		// 	config.params.domain=domain
    // 		// 	config.params = JSON.stringify(config.params);
    // 		// }else{
    // 		//     let dataStr=JSON.parse(config.params);
    // 		// 	dataStr.domain=domain
    // 		// 	config.params = JSON.stringify(dataStr);
    // 		// }
    // 		// config.params.domain=domain
    // 		// let dataStr=JSON.parse(config.params);
    // 		// dataStr.domain=domain
    // 		// config.params = JSON.stringify(dataStr);
    // 	}
    // }
    // 在发送请求之前做些什么 token
    if (Session.get('token')) {
      config.headers.common['Authorization'] = 'Bearer' + " " + Session.get('token')
      config.headers.common["Access-Control-Allow-Origin"] = "*"
      config.headers.common["token"] = Session.get('token')
      config.headers.common["Access-Control-Allow-Credentials"] = true

    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.data.code != 200 && response.data.msg != null && response.config.url != "support/upYun/newBreakpointResume") {
      Message.error(response.data.msg);
      // this.$message.error()
    }
    if (response.data.code == 10001) {
      Session.remove('token')
      Session.clear();
      router.push('/home');
      MessageBox.alert('你已被登出，请重新登录', '提示', {})
    }
    return response;

    // // 对响应数据做点什么
    // const res = response.data;
    // if (res.code !== 200) {
    // 	// `token` 过期或者账号已在别处登录
    // 	if (res.code === 401 || res.code === 4001) {
    // 		// 清除浏览器全部临时缓存
    // 		clearSession();
    // 		router.push('/login');
    // 		store.commit('setMenuData', {});
    // 		resetRouter(); // 重置路由
    // 		MessageBox.alert('你已被登出，请重新登录', '提示', {})
    // 			.then(() => {})
    // 			.catch(() => {});
    // 	}else if(res.code == 0){
    // 		 Message.error(res.msg)
    // 	}
    // 	return Promise.reject(service.interceptors.response.error);
    // } else {
    // 	return response.data;
    // }
  },
  (error) => {
    // 对响应错误做点什么
    if (error.message.indexOf('timeout') != -1) {
      Message.error('网络超时');
    } else if (error.message == 'Network Error') {
      Message.error('网络连接错误');
    } else {
      Message.error(error.response.data.message);
    }
    return Promise.reject(error);
  }
);


export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js